<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Miscs</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        <el-table-column
                            min-width="100"
                            prop="status"
                            label="Status"
                            align="center"
                            header-align="center"
                        >
                            <template slot-scope="scope">
                                <span class="badge badge-default m-1" :class="{ 'badge-success' : scope.row.status}" >{{ scope.row.status }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            min-width="350"
                            prop="value"
                            label="Value"
                            align="left"
                            header-align="left"
                        >
                            <template slot-scope="scope">
                                <span v-if="typeof(scope.row.value) == 'object'" class="badge badge-default m-1" v-for="(val, index) in scope.row.value" :key="index">{{ val }}</span>
                                <span v-if="typeof(scope.row.value) != 'object'" class="" >{{ scope.row.value }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :min-width="135" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <n-button
                                    @click.native="handleView(props.$index, props.row)"
                                    class="view"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-eye"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleEdit(props.$index, props.row)"
                                    class="edit"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleDelete(props.$index, props.row)"
                                    class="remove"
                                    type="danger"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-times"></i>
                                </n-button>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Add New Misc</h4>
            <form>
                <div class="row">
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="feature"
                            label="Feature"
                            v-validate="modelValidations.feature"
                            :error="getError('feature')"
                            v-model="model.feature">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="status"
                            label="Status"
                            v-validate="modelValidations.status"
                            :error="getError('status')"
                            v-model="model.status">
                            <n-switch v-model="model.status" on-text="True" off-text="False"></n-switch>
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <tabs type="primary" class="mt-3" v-model="activeTab" @change="tabChange()">
                            
                            <tab-pane label="Text" centered>
                                <fg-input
                                    v-if="(activeTab == 'Text')"
                                    type="text"
                                    required
                                    name="value"
                                    label="Textual Value"
                                    v-validate="modelValidations.value"
                                    :error="getError('value')"
                                    v-model="model.value">
                                </fg-input>
                            </tab-pane>

                            <tab-pane label="Number" >
                                <fg-input
                                    v-if="(activeTab == 'Number')"
                                    type="number"
                                    required
                                    name="value"
                                    label="Numerical Value"
                                    v-validate="modelValidations.value"
                                    :error="getError('value')"
                                    v-model="model.value">
                                </fg-input>
                            </tab-pane>

                            <tab-pane label="Boolean">
                                <fg-input
                                    v-if="(activeTab == 'Boolean')"
                                    type="text"
                                    required
                                    name="value"
                                    label="Boolean Value"
                                    v-validate="modelValidations.value"
                                    :error="getError('value')"
                                    v-model="model.value">
                                    <n-switch v-model="model.value" on-text="True" off-text="False"></n-switch>
                                </fg-input>
                            </tab-pane>

                            <tab-pane label="Tags">
                                <div v-if="(activeTab == 'Tags')">
                                    <el-tag :key="index" v-for="(val, index) in model.value" size="small" type="primary" :closable="true" :close-transition="false" @close="handleClose(val)">{{ val }}</el-tag>
                                    <input type="text" placeholder="Add new tag" class="form-control input-new-tag" v-model="model.input" ref="saveTagInput" size="mini" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                                </div>
                            </tab-pane>

                        </tabs>
                    </div>
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate()" type="primary">Save Misc</n-button>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import { Pagination as NPagination, Modal, Switch, Tabs, TabPane } from "src/components";
import users from "../../../Dashboard/Tables/users";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Switch.name]: Switch,
        [Tag.name]: Tag,
        Modal,
        Tabs,
        TabPane
    },
    computed: {
        ...mapGetters({
            tableData: 'getMiscs',
            preferences: 'getPreferences'
        }),
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "feature" ],
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 100,
                },
                {
                    prop: "feature",
                    label: "Feature",
                    minWidth: 150,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return `${cellValue.charAt(0).toUpperCase() + cellValue.slice(1)}`; 
                    }
                }
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false
            },
            model: {
                feature: '',
                status: false,
                value: ''
            },
            modelValidations: {
                feature: {
                    required: true,
                },
                status: {
                    required: true,
                },
                value: {
                    required: true,
                },
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
            activeTab: 'Text'
        };
    },
    methods: {
        handleView(index, row) {
            swal({
                title: `You liked ${row.feature}`,
                buttonsStyling: false,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill"
            });
        },
        handleEdit(index, row) {
            this.model.feature = row.feature
            this.model.status = row.status
            this.model._id = row._id
            this.model.value = row.value
            this.scope = 'edit'

            // console.log(typeof(this.model.value));
            
            switch(typeof(this.model.value)){
                case 'object':
                    this.activeTab = 'Tags'
                    break;
                case 'boolean':
                    this.activeTab = 'Boolean'
                    break;
                case 'string':
                    if(!isNaN(this.model.value))
                        this.activeTab = 'Number'
                    else
                        this.activeTab = 'Text'
                    break;
            }
            
            this.$nextTick(() => {
                this.model.value = row.value
            });

            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        deleteRow(row) {
            // let indexToDelete = this.tableData.findIndex(
            //     tableRow => tableRow.id === row.id
            // );
            // if (indexToDelete >= 0) {
            //     this.tableData.splice(indexToDelete, 1);
            // }
            this.$store.dispatch('deleteMisc', row.feature)
        },
        openModal(){

            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });
            
            this.model._id = null
            this.model.feature = ''
            this.model.status = false
            this.model.value = ''
            this.scope = 'add'
            this.modals.add = true
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){
                    
                    switch(this.scope){
                        case 'add'  : this.$store.dispatch('createMisc', this.model); break;
                        case 'edit' : this.$store.dispatch('updateMisc', this.model); break;
                    }
                    
                    this.modals.add = false
                }
            });
        },
        handleClose (val) {
            this.model.value.splice(this.model.value.indexOf(val), 1)
        },
        handleInputConfirm () {
            let inputValue = this.model.input
            if (inputValue) {
                this.model.value.push(inputValue)
            }
            this.model.input = ''
        },
        tabChange(){
            switch(this.activeTab){
                case 'Text'     : this.model.value = '';    break;
                case 'Number'   : this.model.value = 0;     break;
                case 'Boolean'  : this.model.value = false; break;
                case 'Tags'     : this.model.value = [];    break;
            }
        }
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getMiscs');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
.bootstrap-switch{
    display: block;
    width: 90px!important;
    height: 35px!important;

    &.bootstrap-switch-on{
        .bootstrap-switch-label{
            left: 70%;
        }
    }

    .bootstrap-switch-label{
        width: 35px!important;
        height: 35px!important;
    }

    .bootstrap-switch-handle-off,
    .bootstrap-switch-handle-on{
        font-weight: bold;
        line-height: 22px;
        text-indent: 10px;
        color: #273c75!important;
    }
    .bootstrap-switch-handle-off{
        text-indent: 20px;
    }
}

.has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }
    
</style>

